import React from "react";
import ToolCard from "./ToolCard";
import { FiMessageSquare, FiDatabase, FiShield, FiColumns, FiFileText, FiActivity } from "react-icons/fi";

function ToolsSection({ onToolSelect }) {
  const tools = [
    {
      id: "veeva-vault-migration",
      icon: FiDatabase,
      title: "Vault CRM Migration",
      description: "AI-powered migration from Veeva CRM to Vault CRM with intelligent field mapping, document transformation, and vocabulary conversion.",
      color: "#A100FF",
      status: "available",
      features: ["Field Mapping", "Document Migration", "Vocabulary Transform"]
    },
    {
      id: "veeva-gpt",
      icon: FiMessageSquare,
      title: "Veeva GPT",
      description: "Intelligent assistant for Veeva CRM and Vault operations, document search, and workflow automation.",
      color: "#A100FF",
      status: "available",
      features: ["AI Chat", "Document Search", "Workflow Help"]
    },
    {
      id: "doc-redact",
      icon: FiShield,
      title: "DocRedact",
      description: "An AI-powered tool that streamlines document redaction by automatically identifying and masking sensitive information with precision.",
      color: "#A100FF",
      status: "coming-soon",
      features: ["Auto-Redaction", "PII Detection", "Secure Processing"]
    },
    {
      id: "docs-compare",
      icon: FiColumns,
      title: "Docs Compare",
      description: "An intelligent tool that compares documents side-by-side to identify differences, additions, and deletions with detailed analysis.",
      color: "#A100FF",
      status: "coming-soon",
      features: ["Side-by-Side View", "Diff Analysis", "Change Tracking"]
    },
    {
      id: "doc-template-converter",
      icon: FiFileText,
      title: "Document Template Converter",
      description: "An intelligent application that automates reformatting Word documents into template-compliant formats while preserving original content.",
      color: "#A100FF",
      status: "coming-soon",
      features: ["Template Compliance", "Auto-Reformatting", "Content Preservation"]
    },
    {
      id: "universal-patient-language",
      icon: FiActivity,
      title: "Universal Patient Language",
      description: "An AI-powered tool that transforms complex medical information into clear, patient-friendly language to improve understanding and support.",
      color: "#A100FF",
      status: "coming-soon",
      features: ["Medical Simplification", "Patient-Friendly", "AI Translation"]
    }
  ];

  return (
    <section className="tools-section">
      <div className="tools-section-inner">
        <div className="section-header">
          <h2 className="section-title">Available Automations &amp; AI Tools</h2>
          <p className="section-subtitle">
            AI solutions for your transformation journey
          </p>
        </div>
        <div className="tools-grid">
          {tools.map((tool) => (
            <ToolCard key={tool.id} tool={tool} onSelect={() => onToolSelect(tool.id)} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ToolsSection;